import { useTranslation } from 'react-i18next';

import { Box, ErrorState, Button } from '@hawkins/components';
import { Dimensions } from '@hawkins/variables';

import { TranslationNamespace } from '../../types';
import { Page } from '../Page';
import { useNavigate } from 'react-router-dom';

export default function Error() {
  const { t } = useTranslation(TranslationNamespace.LEP);
  const navigate = useNavigate();

  return (
    <Page>
      <Box display="flex" justifyContent="center" paddingX={Dimensions.Space16}>
        <ErrorState
          actions={
            <Button onClick={() => navigate('/')} variant="primary">
              {t('return_home')}
            </Button>
          }
          title={t('error_msg_2')}
        />
      </Box>
    </Page>
  );
}
